import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import { ImportantNotice, FeatureMarquee, NetworkMarquee } from "./components/Marquees";
import Services from "./components/Services";
import { HowItWorks, ESim } from "./components/Process";
import CommonIssues from "./components/CommonIssues";
import HelpGuides from "./components/HelpGuides";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import WhySection from "./components/WhySection";
import { Footer, CookieBanner } from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import useReveal from "./hooks/useReveal";

const Home = () => {
  useReveal();
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ImportantNotice />
        <FeatureMarquee />
        <NetworkMarquee />
        <Services />
        <HowItWorks />
        <ESim />
        <CommonIssues />
        <HelpGuides />
        <Testimonials />
        <FAQ />
        <WhySection />
      </main>
      <Footer />
      <CookieBanner />
      <Toaster />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
